/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SetupParameterType {
  No = 'No',
  Mandatory = 'Mandatory',
  Optional = 'Optional'
}
